/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Badge,
  Card,
  Select,
  InputNumber,
  Divider,
  Typography,
  Modal,
  Tabs,
  Table,
} from "antd";
import { Row, Col, Space, Upload } from "antd";
// import { Upload,Modal } from "antd";
import {
  SaveFilled,
  SearchOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { ButtonBack, uploadButton } from "../../../components/button/index.js";
// import { uploadButton } from "../../../components/button/index.js";
import { PG } from "./model.js";
import { useLocation, useNavigate } from "react-router";
import { delay, BACKEND_URL_MAIN } from "../../../utils/util.js";
import { listcolumnsEditable, componentsEditable } from "./model.js";
import { GiMetalBar } from "react-icons/gi";

import Swal from "sweetalert2";
import PGservice from "../../../service/ERP/PG.service.js";
import OptionService from "../../../service/ERP/Options.service.js";
// import { Authenticate } from "../../../service/Authenticate.service.js";

import ModalBrand from "../../../components/modal/ERP/brand/ModalBrand";
import ModalFG from "../../../components/modal/ERP/fg/ModalFG";
import ModalPacking from "../../../components/modal/ERP/packing/ModalPacking.jsx";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";
import { ModalInkFormat } from "../../../components/modal/ERP/ink-format/";
import ModalBom from "../../../components/modal/ERP/bom-for-PI/ModalBom";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const pgservice = PGservice();
const opService = OptionService();
// const authService = Authenticate();
const { Text } = Typography;

/* ประเภทหน่วยบรรจุ/ขายของสินค้า
   หมายเหตุ: คอลัมน์ er_pg.pack_type เป็น VARCHAR(10) จึงใช้รหัสสั้น ไม่ต้องแก้โครงสร้าง DB
   ค่าเดิม "PALLET" (ยังไม่ระบุวัสดุ) ยังใช้ได้ปกติ แสดงเป็นตัวเลือกเดิมไว้ */
const PACK_TYPE_OPTIONS = [
  { value: "CARTON", label: "Carton" },
  { value: "PALLET_P", label: "Pallet พลาสติก" },
  { value: "PALLET_W", label: "Pallet ไม้" },
];

/* ตัวเลือกสำหรับข้อมูลเก่าที่บันทึกเป็น PALLET เฉย ๆ — แสดงให้เห็นแต่ไม่แนะนำให้เลือกใหม่ */
const PACK_TYPE_LEGACY = { value: "PALLET", label: "Pallet (ไม่ระบุวัสดุ)" };

/* ปริมาตรต่อ 1 กล่อง (CBM) คำนวณสดจากขนาดกล่องของ Packing ที่ผูกไว้

   ขนาดใน er_packing (wide/long/high) เก็บเป็น "เซนติเมตร"
   cm x cm x cm = cm3   แล้ว 1 m3 = 1,000,000 cm3   จึงหารด้วย 1,000,000

   เดิมหารด้วย 1,000,000,000 (คิดว่าเป็นมิลลิเมตร) ค่าที่ได้จึงน้อยกว่าจริง 1,000 เท่า
   เช่นกล่อง 28 x 37 x 17 cm ได้ 0.000018 ทั้งที่ของจริงคือ 0.017612 CBM

   ด้านใดด้านหนึ่งว่าง/เป็น 0 จะไม่คำนวณ */
const CM3_PER_M3 = 1000000;

const cbmFromPacking = (d = {}) => {
  const w = Number(d.packing_wide || 0);
  const l = Number(d.packing_long || 0);
  const h = Number(d.packing_high || 0);
  if (w <= 0 || l <= 0 || h <= 0) return null;
  return (w * l * h) / CM3_PER_M3;
};

/* ข้อความขนาดกล่อง เช่น 28 x 37 x 17 cm (ไว้แสดงเป็นคำอธิบาย) */
const packingDimText = (d = {}) => {
  const parts = [d.packing_wide, d.packing_long, d.packing_high]
    .map((v) => Number(v || 0))
    .filter((v) => v > 0)
    .map((v) => String(Number(v.toFixed(4))));
  return parts.length === 3 ? `${parts.join(" x ")} cm` : "";
};

const packTypeOptions = (currentValue) =>
  currentValue === PACK_TYPE_LEGACY.value
    ? [...PACK_TYPE_OPTIONS, PACK_TYPE_LEGACY]
    : PACK_TYPE_OPTIONS;

const from = "/ERP/packing-goods";

const MyManage = () => {
  const { TextArea } = Input;
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();
  // const [formImage] = Form.useForm();
  const [formDetail, setFormDetail] = useState(PG);
  const [optionPrefix, setOptionPrefix] = useState([]);
  const [openModalBrand, setOpenModalBrand] = useState(false);
  const [openModalFG, setOpenModalFG] = useState(false);
  const [openModalPacking, setOpenModalPacking] = useState(false);
  const [openModalUnit, setOpenModalUnit] = useState(false);
  const [openInkModal, setOpenInkModal] = useState(false);
  const [openModalMaterial, setOpenModalMaterial] = useState(false);

  const [prefixCode, setPrefixCode] = useState(null);
  const [pgCode, setPgCode] = useState("");

  const [listMaterial, setlistMaterial] = useState([]); // รายการวัสดุที่ใช้ในการปิดฉลาก

  /// upload image
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("Preview");

  useEffect(() => {
    // setLoading(true);
    GetPrefix();
    if (config?.action !== "create") {
      getsupData(config.code);
    } else {
      // form.setFieldValue("weight_nw", 0);
      // form.setFieldValue("weight_gw", 0);
    }
    // console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);

  useEffect(() => {
    fnsetPGcode(); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(fgCode);
  }, [form.getFieldValue("pg_code")]);

  const handlePreview = async (file) => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    // setPreviewTitle(""
    //   // file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    // );
  };

  const onSelectInkFormat = (value) => {
    setFormDetail((prev) => ({
      ...prev,
      ink_id: value.ink_id,
      ink_name: value.ink_name,
    }));
  };

  const handleDelete = (v) => {
    const itemDetail = [...listMaterial];
    const newData = itemDetail
      .filter((item) => item?.seq !== v.seq)
      .map((item, index) => ({ ...item, seq: index + 1 }));
    setlistMaterial([...newData]);
  };

  /* v = อาร์เรย์ของวัสดุที่เลือกจาก ModalBom (แท็บ "มาตรฐานการปิดฉลาก")
     เดิมโค้ดอ่าน v.fg_code / v.fg_name / v.typename จากอาร์เรย์ ซึ่งได้ undefined
     แล้ว setFieldsValue ทับลงฟอร์ม ทำให้ข้อมูลพื้นฐาน (FG ฯลฯ) หายไป
     และตอนกดบันทึกก็เขียนค่าว่างทับใน DB

     การเลือกวัสดุปิดฉลากไม่ควรไปแตะฟิลด์ข้อมูลพื้นฐานเลย จึงอัปเดตเฉพาะตารางวัสดุ */
  const handleChooseMat = (v) => {
    const rows = Array.isArray(v) ? v : v ? [v] : [];
    setlistMaterial(rows.map((item, index) => ({ ...item, seq: index + 1 })));
  };

  const handleRemove = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);
    //message.success(`File deleted successfully`);
  };

  const onRemove = (file) => {
    // console.log(file);
    //debugger
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const formData_Del = new FormData();
          formData_Del.append("img_id", file.img_id);
          formData_Del.append("file", file);
          formData_Del.append("uid", file.uid);
          formData_Del.append("stcode", form.getFieldValue("pg_code"));
          formData_Del.append("filename", file.name);

          const actions =
            config?.action !== "create"
              ? pgservice.deletePicUpdate(formData_Del)
              : pgservice.deletePic(formData_Del);

          actions.then(async (res) => {
            //debugger
            let { status, data } = res;
            if (status === 200 && data.status === "1") {
              handleRemove(file);
            } else {
              // alert(data.message)
            }
          });
        } catch (error) {
          message.error("Failed to delete file");
        }
      }
    });

    // console.log(fileList);
  };

  const onUploadSuccess = (file) => {
    //debugger
    // alert(`${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name);
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url:
        `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
        form.getFieldValue("pg_code") +
        "/" +
        "Item_Pic" +
        "_" +
        file.name,
      // url: `${BACKEND_URL_MAIN}/uploads/ERP/Items/`+ form.getFieldValue("pg_code") + '/' + file.uid + "_" + file.name,
    };
    setFileList((prevFileList) => [...prevFileList, newFile]);
    // console.log(file);
    // console.log('-----');
    // console.log(fileList);
  };

  const fnsetPGcode = () => {
    setPgCode(
      (form.getFieldValue("prefixLabel") !== undefined
        ? form.getFieldValue("prefixLabel")
        : "") +
        (form.getFieldValue("prefixLabel") !== undefined &&
        form.getFieldValue("pg_code") !== undefined
          ? "-"
          : "") +
        (form.getFieldValue("pg_code") !== undefined
          ? form.getFieldValue("pg_code")
          : ""),
    ); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "pg" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedFG = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      fg_code: value.fg_code,
      fg_name: value.fg_name,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedPacking = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      packing_code: value.packing_code,
      packing_name: value.packing_name,
      /* เก็บขนาดกล่องไว้คำนวณปริมาตร (CBM) — ไม่ได้บันทึกลง DB */
      packing_wide: value.wide,
      packing_long: value.long,
      packing_high: value.high,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedBrand = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      brand_code: value.brand_code,
      brand_name: value.brand_name,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const getsupData = (v) => {
    pgservice
      .get(v)
      .then(async (res) => {
        const { data, file, pllist } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });
        form.setFieldValue("pg_code1", data.pg_code);

        let fileurl = file.map((data) => ({
          ...data,
          file_name:
            `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
            form.getFieldValue("pg_code") +
            "/" +
            data.file_name,
        }));
        // console.log(fileurl) ;
        const formattedFileList = fileurl.map((data) => ({
          img_id: data.img_id,
          uid: data.uid,
          name: data.name,
          status: "done",
          url: data.file_name,
        }));
        setFileList(formattedFileList);
        setlistMaterial(pllist.map((item, index) => ({ ...item, seq: index + 1 })));
        form.setFieldsValue({ prod_img: formattedFileList });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation PG.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then(() => {
      const source = {
        ...formDetail,
        ...form.getFieldsValue(),
        prefixLabel: form.getFieldValue("prefixLabel"),
        plList: listMaterial,
      };

      // const parm = { header, detail };

      const actions =
        config?.action !== "create"
          ? pgservice.update(source)
          : pgservice.create(source);

      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "บันทึกไม่สำเร็จ");
        });
    });
  };

  const handleAdd = () => {
    // setOpenInkModal(true);
    setOpenModalMaterial(true);
    // const newRow = {
    //   seq: dataList.length + 1, // กำหนด seq ใหม่
    //   qty: 1, // ค่าเริ่มต้น
    //   pk_code: "", // ค่าเริ่มต้นสำหรับรหัสวัตถุดิบ
    //   pk_name: "", // ค่าเริ่มต้นสำหรับชื่อวัตถุดิบ
    //   typename: "", // ค่าเริ่มต้นสำหรับประเภท
    //   unit: "", // ค่าเริ่มต้นสำหรับหน่วย
    // };
  };

  const handleCancel = () => setPreviewOpen(false);

  const handleSave = (row) => {
    setlistMaterial((prev) => {
      const idx = prev.findIndex((item) => row.seq === item.seq);
      if (idx < 0) return prev;
      const clone = [...prev];
      clone.splice(idx, 1, { ...clone[idx], ...row });
      return clone;
    });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id);
          opService
            .optionsGetLastcode({ p: "packaging", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.text,
              };
              setFormDetail(val);
            });
          fnsetPGcode(); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value + " - " + item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {pgCode && pgCode !== "NaN" && (
        <span style={{ paddingLeft: "20px" }}>
          {"ตัวอย่างรหัสใหม่ " + pgCode}
        </span>
      )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const propsAdd = {
    customRequest: async ({ file, onSuccess, onError }) => {
      if (
        form.getFieldValue("pg_code") !== "" &&
        form.getFieldValue("pg_code") !== undefined
      ) {
        // console.log(fileList);
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
        const fileExtension = file.name.slice(
          ((file.name.lastIndexOf(".") - 1) >>> 0) + 2,
        ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
        if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
          message.error("สกุลไฟล์ไม่ถูกต้อง");
          onError();
          return false;
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uid", file.uid);
          formData.append("stcode", form.getFieldValue("pg_code"));
          formData.append("stcode_type", "PG");
          // console.log(file)
          try {
            pgservice.uploadPic(formData).then(async (res) => {
              //debugger
              let { status, data } = res;
              if (status === 200 && data.status === "1") {
                onUploadSuccess(file);
                onSuccess();
                message.success(`${file.name} file uploaded successfully`);
              } else {
                // alert(data.message)
              }
            });
          } catch (error) {
            onError(error);
            message.error(`${file.name} file upload failed.`);
          }
        }
        // console.log(fileList);
      } else message.error(`กรุณากรอกรหัสสินค้าก่อน.`);
    },
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>Basic Data</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>PG Code</span>
                {redcode}
              </span>
            }
            name="pg_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetPGcode()}
              placeholder="Enter PG Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="PG Code" name="pg_code1">
            <Input readOnly style={{ backgroundColor: "#fff" }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item
            label="PG Thai Name"
            name="pg_name"
            rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
          >
            <Input placeholder="Enter PG Thai Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item name="pg_stname_cus" label="Customer PG Name">
            <Input placeholder="Enter Customer PG Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item label="PG Invoice Name" name="pg_ivname">
            <Input placeholder="Enter PG English Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={8}>
          <Form.Item
            label="Finished Goods :"
            name="fg_code"
            // rules={[{ required: true, message: "Please choose data!" }]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Finished Goods"
                value={
                  !!formDetail.fg_name
                    ? `${formDetail.fg_code} / ${formDetail.fg_name} `
                    : ""
                }
                style={{ backgroundColor: "#fff" }}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalFG(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={8}>
          <Form.Item
            label="Packing :"
            name="packing_code"
            // rules={[{ required: true, message: "Please choose data!" }]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Packing"
                value={
                  !!formDetail.packing_name
                    ? `${formDetail.packing_code} / ${formDetail.packing_name} `
                    : ""
                }
                style={{ backgroundColor: "#fff" }}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalPacking(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        {/* ปริมาตรต่อกล่อง คำนวณจากขนาดกล่องของ Packing แก้ไขเองไม่ได้ */}
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item
            label="ปริมาตร/กล่อง (CBM) :"
            tooltip={
              packingDimText(formDetail)
                ? `คำนวณจากขนาดกล่อง ${packingDimText(formDetail)} (กว้าง x ยาว x สูง) หาร 1,000,000`
                : "เลือก Packing ที่มีขนาดกล่องครบทั้ง 3 ด้าน ระบบจะคำนวณให้อัตโนมัติ"
            }
          >
            <Input
              readOnly
              disabled
              value={
                cbmFromPacking(formDetail) !== null
                  ? cbmFromPacking(formDetail).toFixed(3)
                  : ""
              }
              placeholder="คำนวณอัตโนมัติจาก Packing"
              suffix={
                packingDimText(formDetail) ? (
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {packingDimText(formDetail)}
                  </Text>
                ) : null
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
                style={{ backgroundColor: "#fff" }}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item
            label="แบรนด์ :"
            name="brand_code"
            // rules={[{ required: true, message: "Please choose data!" }]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Brand"
                value={
                  !!formDetail.brand_name ? `${formDetail.brand_name} ` : ""
                }
                style={{ backgroundColor: "#fff" }}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalBrand(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Form.Item name="allergen" label="สารก่อภูมิแพ้ :">
            <Input placeholder="Enter สารก่อภูมิแพ้" />
          </Form.Item>
        </Col>
        </Row>
        
      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Form.Item
            name="pack_type"
            label="ประเภทหน่วยบรรจุ"
            tooltip="ใช้ระบุว่าสินค้านี้นับเป็น Carton, Pallet พลาสติก หรือ Pallet ไม้"
          >
            <Select
              size="large"
              style={{ width: "100%" }}
              placeholder="เลือกประเภท (ไม่เลือก = Carton)"
              options={packTypeOptions(formDetail?.pack_type)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Form.Item name="unit_cs" label="Unit/cs">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Unit/cs"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Form.Item name="net_wt" label="Net Weight (kg)">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Net Weight"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Form.Item name="gross_wt" label="Gross Weight (kg)">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Gross Weight"
            />
          </Form.Item>
        </Col>
          {/* Shelf life ย้ายไปอยู่ที่ Master FG อย่างเดียว ไม่เก็บซ้ำใน PG */}
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>Other Data</Divider>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="remarks" label="Remark">
            <TextArea rows={4} placeholder="Enter Remark " />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={4}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          รูปสินค้า
          <Form.Item
            name="prod_img"
            getValueFromEvent={(event) => {
              return event?.fileList;
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาอัพโหลดรูปสินค้า!",
            //   },
            // ]}
          >
            <Upload
              {...propsAdd}
              fileList={fileList}
              listType="picture-card"
              onPreview={handlePreview}
              onRemove={onRemove}
            >
              {fileList.length >= 2 ? null : uploadButton}
            </Upload>
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
          >
            บันทึก
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const MasterContent = (
    <>
      <Form
        form={form}
        name="form_in_modal_add"
        layout="vertical"
        autoComplete="off"
        initialValues={{
          modifier: "public",
        }}
      >
        <Card title={config?.title}>{Detail}</Card>
      </Form>
    </>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Packing Information
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
            <Button
              className="bn-success-outline"
              size="default"
              style={{ display: "flex", alignItems: "center" }}
              icon={
                <GiMetalBar
                  style={{
                    fontSize: "1.15rem",
                    marginRight: 4,
                    verticalAlign: "middle",
                    marginBottom: 2,
                  }}
                />
              }
              onClick={() => handleAdd()}
            >
              Add Packing Information
            </Button>
          </Col>
        </Flex>
      </Col>
    </Flex>
  );

  const column = listcolumnsEditable(handleSave, {
    handleDelete,
  });

  const MaterialTableContent = (
    <>
      <Card>
        <Space
          direction="vertical"
          size="middle"
          style={{ display: "flex", position: "relative" }}
        >
          <Table
            title={() => TitleTable}
            components={componentsEditable}
            rowClassName={() => "editable-row"}
            bordered
            dataSource={listMaterial|| []}
            columns={column}
            pagination={false}
            rowKey="seq"
            scroll={{ x: "max-content" }}
            size="small"
            // summary={(_) => TableSummary()}
          />
        </Space>
      </Card>
    </>
  );

  const PackingInformationContent = (
    <>
      <Divider {...dividerProp}>มาตรฐานจำนวนกล่อง / ตู้</Divider>
      <Col xs={24} sm={24} md={24} lg={12} xl={6}>
        {/* ใช้คำนวณจำนวนตู้ (FCL) ในแผนโหลด — จำนวนกล่องที่บรรจุได้ต่อ 1 ตู้ */}
        <Form.Item name="container_std" className="!mb-0">
          <InputNumber
            min={0}
            controls={false}
            placeholder="จำนวนกล่องต่อ 1 ตู้"
            style={{ width: "100%", height: 40 }}
          />
        </Form.Item>
      </Col>

      <Divider {...dividerProp}>จุดพิมพ์รหัส</Divider>
      <Col xs={24} sm={24} md={24} lg={12} xl={6}>
        {/* จุดที่พิมพ์รหัสลงสินค้า — ใช้ในใบสั่งงานการผลิต */}
        <Form.Item name="print_point" className="!mb-0">
          <Select
            allowClear
            placeholder="เลือกจุดพิมพ์รหัส"
            style={{ width: "100%", height: 40 }}
            options={[
              { value: "ผลิต (FG)", label: "ผลิต (FG)" },
              { value: "คลังสินค้า (PG)", label: "คลังสินค้า (PG)" },
            ]}
          />
        </Form.Item>
      </Col>

      <Divider {...dividerProp}>รูปแบบอิงค์</Divider>
      <Col xs={24} sm={24} md={24} lg={12} xl={6}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            readOnly
            placeholder="Select Ink Format"
            value={!!formDetail.ink_name ? `${formDetail.ink_name}  ` : ""}
            style={{ backgroundColor: "#fff" }}
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => setOpenInkModal(true)}
            style={{ minWidth: 40 }}
          ></Button>
        </Space.Compact>
      </Col>
      <Divider {...dividerProp}>รายละเอียด</Divider>
      {MaterialTableContent}
    </>
  );

  

  const items = [
    {
      key: "1",
      label: "ข้อมูลพื้นฐาน",
      children: MasterContent,
    },
    {
      key: "2",
      label: "มาตรฐานการปิดฉลาก",
      children: PackingInformationContent,
    },
  ];
  return (
    <div className="pg-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      {/* <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal> */}
      <Space direction="vertical" className="flex gap-2">
        {SectionBottom}
        <Tabs
          hideAdd
          defaultActiveKey="1"
          // activeKey={activeKey}
          items={items}
        />
        {SectionBottom}
      </Space>

      {openInkModal && (
        <ModalInkFormat
          show={openInkModal}
          close={() => setOpenInkModal(false)}
          pgCode={formDetail?.pg_code}
          values={(res) => onSelectInkFormat(res)}
        />
      )}

      {openModalBrand && (
        <ModalBrand
          show={openModalBrand}
          close={() => {
            setOpenModalBrand(false);
          }}
          values={(v) => {
            handleChoosedBrand(v);
          }}
        ></ModalBrand>
      )}

      {openModalFG && (
        <ModalFG
          show={openModalFG}
          close={() => {
            setOpenModalFG(false);
          }}
          values={(v) => {
            handleChoosedFG(v);
          }}
        ></ModalFG>
      )}

      {openModalPacking && (
        <ModalPacking
          show={openModalPacking}
          close={() => {
            setOpenModalPacking(false);
          }}
          values={(v) => {
            handleChoosedPacking(v);
          }}
        ></ModalPacking>
      )}

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        ></ModalUnit>
      )}

      {openModalMaterial && (
        <ModalBom
          show={openModalMaterial}
          close={() => {
            setOpenModalMaterial(false);
          }}
          values={(v) => {
            handleChooseMat(v);
          }}
          stcode={formDetail?.pg_code}
          selected={listMaterial}
        ></ModalBom>
      )}

      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={1200}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};

export default MyManage;
